import isUndefined from 'lodash/isUndefined';
import React from 'react';

import { ProgramEnum } from '../../models/programs';
import { GenericSurveyQuestion, SurveyQuestionType } from '../models/surveys';
import { GenericProgramSurvey } from '../models/surveysGeneric';
import { BooleanQuestion } from './BooleanQuestion';
import { DateTimeQuestion } from './DateTimeQuestion';
import { DummyQuestion } from './DummyQuestion';
import { OptionsQuestion } from './OptionsQuestion';
import { RateQuestion } from './RateQuestion';
import { SelectQuestion } from './SelectQuestion';
import { SingleOptionQuestion } from './SingleOptionQuestion';
import { StepsQuestion } from './StepsQuestion';
import { TextAreaQuestion } from './TextAreaQuestion';
import { TextQuestion } from './TextQuestion';

export const questionCompontents = {
    [SurveyQuestionType.Options]: OptionsQuestion,
    [SurveyQuestionType.SingleOption]: SingleOptionQuestion,
    [SurveyQuestionType.Text]: TextQuestion,
    [SurveyQuestionType.TextArea]: TextAreaQuestion,
    [SurveyQuestionType.Boolean]: BooleanQuestion,
    [SurveyQuestionType.Rate]: RateQuestion,
    [SurveyQuestionType.Steps]: StepsQuestion,
    [SurveyQuestionType.Select]: SelectQuestion,
    [SurveyQuestionType.DateTime]: DateTimeQuestion,
    [SurveyQuestionType.Dummy]: DummyQuestion,
};

interface Props {
    programId: ProgramEnum;
    surveyId: GenericProgramSurvey;
    question?: GenericSurveyQuestion;
    index?: number;
}

export const SurveyQuestionSwitch: React.SFC<Props> = ({
    programId,
    surveyId,
    question,
    index,
}) => {
    const QuestionComponent = (question &&
        questionCompontents[question.type]) as React.ComponentClass<any>;

    return question && QuestionComponent ? (
        <QuestionComponent
            programId={programId}
            surveyId={surveyId}
            readableIndex={!isUndefined(index) && index + 1}
            {...question}
        />
    ) : null;
};
